import { render, staticRenderFns } from "./EventView.vue?vue&type=template&id=75ada2bb&scoped=true"
import script from "./EventView.vue?vue&type=script&lang=js"
export * from "./EventView.vue?vue&type=script&lang=js"
import style0 from "./EventView.vue?vue&type=style&index=0&id=75ada2bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ada2bb",
  null
  
)

export default component.exports